export default "__VITE_ASSET__DZA9hQIN__"